export default "data:image/webp;base64,UklGRjQAAABXRUJQVlA4TCgAAAAvJ4AGACDStvE8b9N3fjQoECCU8F9JIEB88W9L/yfAVE7NfvaZQ5kD"